module.exports = __webpack_public_path__ + "images/category_lp/farm_machine/assessment_achievements/4@2x_acd6aaa90f6955778637d43938e87f54.png";